import isNull from 'lodash/isNull';

const initializeInputs = {
  orderFormText: '',
  productDescriptionText: '',
  termsAndConditionsText: '',
};

const checkDocuments = ({ orderFormInput, productDescriptionInput, termsAndConditionsInput }) => {
  const array = [];
  if (orderFormInput) array.push(orderFormInput);
  if (productDescriptionInput) array.push(productDescriptionInput);
  if (termsAndConditionsInput) array.push(termsAndConditionsInput);
  return array.join(', ');
};

export const documentTypes = {
  terms: 'TERMS',
  productDescription: 'PRODUCT_DESCRIPTION',
  orderForm: 'ORDER_FORM',
};

export const documentInputFields = {
  [documentTypes.orderForm]: 'orderFormInput',
  [documentTypes.productDescription]: 'productDescriptionInput',
  [documentTypes.terms]: 'termsAndConditionsInput',
};

const shouldBeRemoved = (values, type) => isNull(values[documentInputFields[type]]);

export { initializeInputs, checkDocuments, shouldBeRemoved };
